import { fetchOpenAIText } from "../utils/openaiClient";

export function useProsConsGeneratorLogic({
  prosConsInput, setProsConsInput, prosConsLevel, prosConsPairs,
  setProsConsLoading, generatedProsCons, setGeneratedProsCons,
  currentTab, onInsertToBoard, activeEditor,
  setShowProsConsGenerator, setSelectedTemplate,
}) {
  const handleProsConsGenerate = async () => {
    if (!prosConsInput.trim()) return;
    setProsConsLoading(true);
    try {
      const prompt = `Create a list of pros and cons for the following topic: ${prosConsInput}.\nReturn two lists: one for pros, one for cons. Generate exactly ${prosConsPairs} pros and ${prosConsPairs} cons. Each item should be a clear, simple sentence. The language and complexity must match CEFR level ${prosConsLevel}. Return ONLY valid JSON in this format (arrays must have exactly ${prosConsPairs} items):\n{\n  "pros": ["pro1", "pro2", "..."],\n  "cons": ["con1", "con2", "..."]\n}`;
      const content = await fetchOpenAIText({
        prompt,
        temperature: 0.7,
        maxTokens: 400,
      });
      if (content) {
        const parsed = JSON.parse(content.trim());
        setGeneratedProsCons(parsed);
      }
    } catch (e) {
      // Error generating pros/cons
    } finally {
      setProsConsLoading(false);
    }
  };

  const handleProsConsInsert = () => {
    if (!generatedProsCons) return;
    if (currentTab > 0 && onInsertToBoard) {
      onInsertToBoard(generatedProsCons, 'proscons');
      setShowProsConsGenerator(false);
      setProsConsInput("");
      setSelectedTemplate(null);
      return;
    }
    if (!activeEditor) return;
    activeEditor.chain().focus().insertProsConsExercise({
      topic: prosConsInput,
      cefr: prosConsLevel,
      pros: generatedProsCons.pros,
      cons: generatedProsCons.cons,
      pairs: prosConsPairs,
      hideInstructions: false
    }).run();

    setShowProsConsGenerator(false);
    setProsConsInput("");
    setSelectedTemplate(null);
  };

  return { handleProsConsGenerate, handleProsConsInsert };
}
